
import React from 'react';
import AuthLayout from '../components/AuthLayout';
import SocialLogin from '../components/SocialLogin';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePageTitle } from '../lib/usePageTitle';
import { SignUpForm } from '../components/SignUpForm';

function SignUpPage() {
  usePageTitle('Sign Up');
  const [error, setError] = React.useState<string | string[] | null>(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const joinCode = searchParams.get('join_code') || undefined;

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/current-user');
    }
  }, [navigate]);

  return (
    <AuthLayout title="Sign Up" description="Create your account below.">
      <SignUpForm error={error} setError={setError} onSuccess={() => navigate('/login', { state: { accountCreated: true } })} initialJoinCode={joinCode} />
      <SocialLogin onError={setError} />
    </AuthLayout>
  );
}



export default SignUpPage;
